import React from 'react'

export const Hero = () => {
  return (
    <section className="hero">
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 hero-leftWind">
          <div className='herofirst'>
            <h2 className='WindText'>Investor Relations</h2>
            <p className='text-white px-6'>
            For The People
            </p>
            {/* <button className="btn btn-primary">Get A Quote</button> */}
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}
